export const MODULE_NAME = 'ResetPassword'

export const paths = {
  ResetPassword: '/reset-password',
}
